interface ColorShades {
  shade50: string
  shade100: string
  shade200: string
  shade300: string
  shade400: string
  shade500: string
  shade600: string
  shade700: string
  shade800: string
  shade900: string
}

interface Color {
  main: string
  shades: ColorShades
}

export type ColorTheme = {
  black: string
  white: string
  neutral: Color
  primary: Color
  blue: Color
  secondary: Color
  yellow: Color
  green: Color
  red: Color
};

const colors: ColorTheme = {
  black: '#000000',
  white: '#FFF6F7',
  neutral: {
    main: '#A19CAF',
    shades: {
      shade50: '#FAF9FB',
      shade100: '#F4F3F6',
      shade200: '#E7E5EB',
      shade300: '#D4D1DB',
      shade400: '#A19CAF',
      shade500: '#716B80',
      shade600: '#3E3751',
      shade700: '#171127',
      shade800: '#171127',
      shade900: '#171127',
    },
  },
  primary: {
    main: '#0B0049',
    shades: {
      shade50: '#E7E5F0',
      shade100: '#C3BFDB',
      shade200: '#9C95C3',
      shade300: '#756BAB',
      shade400: '#574B99',
      shade500: '#3A2B87',
      shade600: '#34267F',
      shade700: '#2C1F74',
      shade800: '#24186A',
      shade900: '#0B0049',
    },
  },
  blue: {
    main: '#00E8FC',
    shades: {
      shade50: '#E5F5F7',
      shade100: '#B2F2F9',
      shade200: '#73EEFA',
      shade300: '#33EAFB',
      shade400: '#00E8FC',
      shade500: '#00D1E8',
      shade600: '#00B8CE',
      shade700: '#009EB4',
      shade800: '#00859A',
      shade900: '#006270',
    },
  },
  secondary: {
    main: '#FF0872',
    shades: {
      shade50: '#FFDEEA',
      shade100: '#FFAFCF',
      shade200: '#FF73AE',
      shade300: '#FF3D8D',
      shade400: '#FF0872',
      shade500: '#E60066',
      shade600: '#CC005A',
      shade700: '#B3004E',
      shade800: '#990042',
      shade900: '#80002A',
    },
  },
  yellow: {
    main: '#FFE400',
    shades: {
      shade50: '#FDF5E0',
      shade100: '#FFF1AD',
      shade200: '#FFEC6F',
      shade300: '#FFE731',
      shade400: '#FFE400',
      shade500: '#E6CD00',
      shade600: '#CCB600',
      shade700: '#B39F00',
      shade800: '#998800',
      shade900: '#806200',
    },
  },
  green: {
    main: '#75BF7E',
    shades: {
      shade50: '#F7FBF7',
      shade100: '#E7F4E8',
      shade200: '#B6DDBB',
      shade300: '#8ECB95',
      shade400: '#75BF7E',
      shade500: '#5DB467',
      shade600: '#499F53',
      shade700: '#3C8345',
      shade800: '#306736',
      shade900: '#234B27',
    },
  },
  red: {
    main: '#F87171',
    shades: {
      shade50: '#FEF2F2',
      shade100: '#FEE2E2',
      shade200: '#FECACA',
      shade300: '#FCA5A5',
      shade400: '#F87171',
      shade500: '#EF4444',
      shade600: '#DC2626',
      shade700: '#B91C1C',
      shade800: '#991B1B',
      shade900: '#7F1D1D',
    },
  },
};

export default colors;
